// extracted by mini-css-extract-plugin
export default {"box-annotator":"TEMPAnnotationPage_box-annotator__iBoLG","annotator-container":"TEMPAnnotationPage_annotator-container__NiiRj"};